import React, { useEffect, useState } from "react";
import styled from 'styled-components';
import Pagination from "react-js-pagination";
import "../../../components/Style/Table.css"
import {
  Table,
  TableRow,
  TableHead,
  TableBody,
  TableCell,
  TableContainer,
} from "@material-ui/core";
import OrgCell from "../../../components/OrgCell";

export default function NewPlanMemTable(props){
  const row = ['이름', '등급', '플랜명', '메일', '소속', '플랜 시작일', '플랜 종료일'];
  const totalData = Array.isArray(props.totalData) ? props.totalData : [];
  const [dataCnt, setDataCnt] = useState(0);
  const postPerPage = 5;

  const [page, setPage] = useState(1);
  const [currentPost, setCurrentPost] = useState([]);

  const handlePageChange = (nextPage) => {
    setPage(nextPage);
  };

  useEffect(() => {
    setPage(1);
  }, [totalData]);

  useEffect(() => {
    const start = (page - 1) * postPerPage;
    const end = start + postPerPage;
    setCurrentPost(totalData.slice(start, end));
    setDataCnt(totalData.length);
  }, [totalData, page]);

  return(
    <div>
      <TableContainer>
        <Table className="mb-0">
          <TableHead>
            <TableRow>
              {row && row.map(headerItem => (
                <TableCell key={headerItem} style={{ textAlign: 'center'}}>{headerItem}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {currentPost.map(item => (
              <TableRow key={item.member_seq}>
                <TableCell style={{ textAlign: 'center'}}>{item.name}</TableCell>
                <TableCell style={{ textAlign: 'center'}}>{item.grade_name}</TableCell>
                <TableCell style={{ textAlign: 'center'}}>{item.note || '-'}</TableCell>
                <TableCell style={{ textAlign: 'center'}}>{item.email}</TableCell>
                <TableCell style={{ textAlign: 'center'}}>
                  <OrgCell name={item.org_name} type={item.org_type} />
                </TableCell>
                <TableCell style={{ textAlign: 'center'}}>{item.start_date}</TableCell>
                <TableCell style={{ textAlign: 'center'}}>{item.end_date}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {dataCnt > postPerPage && (
        <PaginationWrap>
          <Pagination
            activePage={page}
            itemsCountPerPage={postPerPage}
            totalItemsCount={dataCnt}
            pageRangeDisplayed={5}
            prevPageText={"<"}
            nextPageText={">"}
            onChange={handlePageChange}
          />
        </PaginationWrap>
      )}
    </div>
  )
}

const PaginationWrap = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 16px;
`;
